'use client';

function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
    </>
  );
}

export { PageLayout };
